export default __webpack_public_path__ + "static/media/envelope-dark.afbc1a0e.svg";